import React, { useState, useEffect } from "react";
import { Col, Row, Button, Modal, Card, Table } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";

import Create from "../../../components/dashboard/MedicalAreas/Create";
import Update from "../../../components/dashboard/MedicalAreas/Update";
import Delete from "../../../components/dashboard/MedicalAreas/Delete";

import endpoints from "../../../services/endpoints";

import "../../../assets/styles/admin.css";

const { Meta } = Card;
const { confirm } = Modal;

export default function MedicalAreas() {
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenCreate, setIsOpenCreate] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(20);

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      width: 100,
    },
    {
      title: "Nome",
      dataIndex: "name",
    },
    {
      title: "",
      dataIndex: "actions",
    },
  ];

  useEffect(() => {
    handleGetData();
  }, []);

  function handleGetData() {
    axios
      .get(endpoints.medicalAreas.read)
      .then((res) => {
        setData(res.data);
        handlePrepareData(res.data);
      })
      .catch((error) => console.error(error));
  }

  function handlePrepareData(data) {
    let newData = [];
    data.forEach((element, index) => {
      newData.push({
        key: index + 1,
        name: element.name,
        actions: (
          <div className="d-flex jc-end">
            <EditOutlined className="mr-10" key="edit" onClick={() => handleOpenUpdate(element)} />
            <DeleteOutlined key="delete" onClick={() => handleOpenDelete(element)} />
          </div>
        ),
      });
    });

    setTableData(newData);
    setIsLoading(false);
  }

  function handleOpenCreate() {
    setIsOpenCreate(true);
  }

  function handleCloseCreate() {
    setIsOpenCreate(false);
    handleGetData();
  }

  function handleOpenUpdate(data) {
    setSelectedData(data);
    setIsOpenUpdate(true);
  }

  function handleCloseUpdate() {
    setIsOpenUpdate(false);
    handleGetData();
  }

  function handleOpenDelete(data) {
    setSelectedData(data);
    setIsOpenDelete(true);
  }

  function handleCloseDelete() {
    setSelectedData({});
    setIsOpenDelete(false);
    handleGetData();
  }

  function handleChangePage(e) {
    setCurrentPage(e);
    if (e <= 1) {
      setMinValue(0);
      setMaxValue(itemsPerPage);
    } else {
      let newMinValue = itemsPerPage * (e - 1);
      let newMaxValue = newMinValue + itemsPerPage;
      setMinValue(newMinValue);
      setMaxValue(newMaxValue);
    }
  }

  return (
    <Row>
      <Create open={isOpenCreate} close={handleCloseCreate} />
      <Update data={selectedData} open={isOpenUpdate} close={handleCloseUpdate} />
      <Delete data={selectedData} open={isOpenDelete} close={handleCloseDelete} />
      <Col span={24}>
        <Row className="title-admin-page d-flex jc-sb ai-center">
          <Col>
            <h2 className="m-0">Áreas Médicas</h2>
          </Col>
          <Col>
            <Button size="large" onClick={handleOpenCreate}>
              Adicionar
            </Button>
          </Col>
        </Row>
        <Table loading={isLoading} columns={columns} dataSource={tableData} />
      </Col>
    </Row>
  );
}
